<template>
  <div class="d-flex col-12 flex m-2">
    <div class="col-9">
      <div class="d-flex align-items-center mt-3  mb-2 no-gutters">
        <div class="row col-6">
          <CustomInput
            class="col-5"
            name="data_inicial"
            label="Período"
            type="date"
            :initial-value="search.data_inicial"
            @setError="setError"
            @blur="setValueInput" />

          <div class="col-1 p-2 m-2 mt-4">
            <div class=" mt-1">
              até
            </div>
          </div>

          <CustomInput
            class="col-5 mt-2"
            name="data_final"
            label=" "
            type="date"
            :initial-value="search.data_final"
            @setError="setError"
            @blur="setValueInput" />
        </div>
        <b-form-group class="ml-3 "
                      label="Status">
          <b-form-radio-group
            id="radio-group-1"
            v-model="search.status"
            :options="computedOptionsStatus"
            name="radio-options" />
        </b-form-group>
      </div>
      <div class="row">
        <CustomInput
          class="col-3"
          name="numero"
          label="Número do protocolado"
          type="number"
          :initial-value="search.numero"
          @setError="setError"
          @blur="setValueInput" />
        <div class="col-2">
          <CustomSelect
            name="ano"
            label="Ano"
            :options="computedOptionsAnos" 
            :selected="search.ano"       
            @setSelectValue="selectOptionAno" />
        </div>

        <CustomInput
          class="col-7"
          name="parte_nome"
          label="Nome requerente"
          type="text"
          :initial-value="search.parte_nome"
          @setError="setError"
          @blur="setValueInput" />
      </div>

      <div class="row mt-3">
        <CustomSelect
          class="row col-8 mr-1"
          :name="natureza"
          label="Natureza"
          :options="computedOptionsNaturezas" 
          :selected="search.natureza"       
          @setSelectValue="selectOptionNatureza" />
  
        <CustomInput
          class="col fill"
          name="matricula"
          label="Matrícula"
          type="text"
          :initial-value="search.matricula"
          @setError="setError"
          @blur="setValueInput" />
      </div>
    </div>
    <div class="d-flex flex-column justify-content-between ml-3">
      <div class="d-flex justify-content-end mt-5">
        <button class="btn btn-secondary relative"
                @click="() => this.$emit('novoProtocolo')">
          <icon-svg icon="add"
                    class="icon--xs icons--white mr-1" />
          Novo protocolo
        </button>
      </div>
      <div class=" d-flex align-items-end">
        <div>
          <button class="btn btn-secondary"
                  @click="filterProtocolos()">
            <icon-svg icon="search"
                      class="icons--white icon--xs" />
            Filtrar
          </button>
        </div>
        <div>
          <button class="btn btn-outline-secondary ml-2"
                  @click="clearFilterProtocolos()">
            Limpar busca
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Services
  import NaturezaProtocoloService from "@/services/NaturezaProtocoloService"

  // Components
  import CustomInput from '@/components/CustomInputs/CustomInput.vue'
  import CustomSelect from '@/components/CustomInputs/CustomSelect.vue'

  //Others
  import moment from 'moment'

  const searchBase = {
    numero: null,
    ano: moment(new Date()).format('YYYY'),
    status: '',
    natureza: null,
    data_inicial: '',
    data_final: '',
    matricula: null,
    parte_nome: null,
    numero: null
  }

  export default {
    name: "ProtocoloSearchForm",
    components: { 
      CustomInput, 
      CustomSelect },
    props: { 
      options: { type: Object, default: null, require: true }
    },
    data () {
      return {
        search: Object.assign({}, searchBase),
        formErros: [],
        selected: [],
        optionsStatus: [
          { text: 'Orange', value: 'orange' },
          { text: 'Apple', value: 'apple' },
          { text: 'Pineapple', value: 'pineapple' },
          { text: 'Grape', value: 'grape' }
        ]
      }
      
    },
    computed: {
      computedOptionsStatus () {
        const options =  this.options.status.map((item) =>  ({ text: item.label, value: item.value } ))
        return options
      },
      computedOptionsNaturezas () {
        const options =  this.options.naturezas.map((item) =>  ({ text: item, value: item, name: 'natureza'} ))
        return options
      },
      computedOptionsAnos () {
        const options =  this.options.anos.map((item) =>  ({ text: item.ano, value: item.ano, name: 'ano'} ))
        return options
      }
    },
    async created () {
      await this.init()
    },
    methods: {
      async init () {
        await this.getNaturezaProtocolos()
      },
      setValueInput (nome, value) {     
        this.search[nome] = value
      },
      setError (newArray) {
        this.formErros = newArray
      },
      selectOptionAno (option) {
        if (!option) return this.search.ano = null
        this.search.ano = option.value
      },
      selectOptionNatureza (option) {
        if (!option) return this.search.natureza = null
        this.search.natureza = option.value
      },
      async changeNatureza (natureza) {
        if (natureza) {
          this.search.natureza = natureza
        }
      },
      async getNaturezaProtocolos () {
        let naturezas = await NaturezaProtocoloService.index()

        naturezas = naturezas
          .filter((natureza) => {
            return natureza.ativo
          })
          .map((natureza) => {
            return natureza.descricao
          })

        this.options.naturezas = naturezas
      },
      filterProtocolos () {
        this.$emit('filterProtocolos', this.search)
      },
      clearFilterProtocolos () {
        this.search = Object.assign({}, searchBase)

      }
    }
  }
</script>

<style scoped>

</style>
